import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c60dd06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Calls" }
const _hoisted_2 = { class: "mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_calls_filters = _resolveComponent("calls-filters")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "История звонков" }),
    _createVNode(_component_calls_filters, {
      onReset: _ctx.resetFilters,
      onSearch: _ctx.applyFilters
    }, null, 8, ["onReset", "onSearch"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.data_state.calls.is_failed && !_ctx.data_state.calls.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.data_state.calls.is_loading,
            text: "При получении списка звонков произошла ошибка",
            "error-message": _ctx.data_state.calls.failure.error_state.message,
            "error-url": _ctx.data_state.calls.failure.error_state.url,
            "error-status": _ctx.data_state.calls.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadCalls(_ctx.data_state.calls.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.data_state.calls.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.data_state.calls.is_loading,
                columns: _ctx.CallsColumns,
                rows: _ctx.data_state.calls.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.data_state.calls.pagination.total_items,
                "pagination-current-page": _ctx.data_state.calls.pagination.current_page,
                "pagination-total-pages": _ctx.data_state.calls.pagination.total_pages,
                onChangePage: _ctx.loadCalls,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ row, column }) => [
                  (column.key === 'invoiceId')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.invoiceId)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              class: "text-blue-500",
                              to: `/invoice/${row.invoiceId}`,
                              target: "_blank"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row.invoiceNumber), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (row.orderId)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                class: "text-blue-500",
                                to: `/order/${row.id}`,
                                target: "_blank"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row.orderNumber), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]))
                            : _createCommentVNode("", true)
                      ], 64))
                    : (column.key === 'courierName' && row.courierId)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          class: "text-blue-500",
                          to: `/couriers/${row.courierId}`,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(row.courierName || '-'), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createTextVNode(_toDisplayString(row[column.key] || '-'), 1)
                        ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}